const IFRAME_SELECTOR = ".video__bg iframe[data-src]";
// Start loading a little before the video scrolls into view.
const PRELOAD_MARGIN = "300px 0px";

function loadIframe(iframe) {
  if (!iframe.getAttribute("src")) {
    iframe.src = iframe.dataset.src;
  }
}

function initBackgroundVideo() {
  const iframes = document.querySelectorAll(IFRAME_SELECTOR);

  if (!iframes.length) return;

  if (!("IntersectionObserver" in window)) {
    iframes.forEach(loadIframe);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        loadIframe(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: PRELOAD_MARGIN }
  );

  iframes.forEach((iframe) => observer.observe(iframe));
}

initBackgroundVideo();
